import { render, staticRenderFns } from "./edit-prize.vue?vue&type=template&id=0513e90e&scoped=true&"
import script from "./edit-prize.vue?vue&type=script&lang=js&"
export * from "./edit-prize.vue?vue&type=script&lang=js&"
import style0 from "./edit-prize.vue?vue&type=style&index=0&id=0513e90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513e90e",
  null
  
)

export default component.exports